import ClientModule from "@gqlapp/module-client-react";
import i18n from "@gqlapp/i18n-client-react";
import storage from "@gqlapp/storage";
import PageNotFound from "@lib/PageNotFound";
import Router from "@gqlapp/router-client-react";
import Modules from "./modules";
export default new ClientModule(storage, i18n, Modules, PageNotFound, Router);

